export const CardList = [
  {
    title: "Support for new language features",
    description:
      "RubyMine 2022.1 adds support for new Ruby and RBS features introduced in Ruby 3.1. This includes support for bounded generics, RBS collection, anonymous block argument forwarding, generic type aliases, and more.",
    img: "1-support-for-new-language-features.webp",
  },
  {
    title: "New Inspections",
    description:
      "This version adds several new inspections which check the usage of type variables in RBS. They report missing type signatures, invalid type argument usage, conflicting type variable variances, incorrect type argument variance, and more.",
    img: "2-new-inspections.webp",
  },
  {
    title: "Overloads in Quick Documentation",
    description:
      "RubyMine can now show overloads in the Quick Documentation look-up (Ctrl+Q). When you invoke Quick Documentation on a method, it will show the current matching overload.",
    img: "3-overloads-in-quick-documentation.webp",
  },
  {
    title: "Inlay hints for Ruby methods based on RBS",
    description:
      "RubyMine now shows inlay hints for Ruby code, based on type signatures from corresponding RBS files. Clicking on a hint will take you to the corresponding type signature.",
    img: "4-inlay-hints.gif",
  },
  {
    title: "A quick-fix for mismatched type signatures",
    description:
      "RubyMine reports inferred types in Ruby code that don’t match the expected type from RBS. Starting with v2022.1, you can quickly navigate to the corresponding RBS file in such cases.",
    img: "5-quick-fix.gif",
  },
  {
    title: "Improved autocompletion for the YARD @overload tag",
    description:
      "RubyMine understands the @overload tag and will suggest all of the declared overloads when showing parameter information. Starting with this version, autocompletion for the @overload tag adds the name of a method that you are describing.",
    img: "6-improved-autocompletion.gif",
  },
];
